import { apiErrors, apiMethodnames } from '../constants/common';
import { DISCOVER, VISA } from '../constants/partnering-networks';
import collapsedLogger from '../helpers/collapsed-logger';
import getNetworkInstance from '../helpers/get-network-instance';
import OrchCustomData from '../helpers/orch-custom-data';
import promiseTimeout from '../helpers/promise-timeout';

const timeOutError = network => ({
  [network]: {
    error: apiErrors.TIME_OUT
  }
});
const promiseRejectError = network => ({
  [network]: {
    error: apiErrors.REJECT
  }
});

const promiseWrapper = function(instance, instanceName, data, method) {
  const obj = {};
  if (instance === null || instance === undefined) {
    obj[instanceName] = {
      error: apiErrors.NO_INSTANCE
    };
    return Promise.resolve(obj);
  }
  collapsedLogger(
    `-- ${instanceName} unbindAppInstance API with network name and input data`,
    data
  );
  if (!instance[method]) {
    obj[instanceName] = {
      error: apiErrors.NO_METHOD
    };
    return Promise.resolve(obj);
  }
  const vco = getNetworkInstance(OrchCustomData, VISA);
  return instance[method](data)
    .then(res => {
      const step = `ORCH_UNBINDAPPINSTANCE_${instanceName}_API_SUCCESS_RESPONSE`;
      OrchCustomData.apiTimeStamp.unbindAppInstance[instanceName].endTime = Date.now();
      obj[instanceName] = res;
      vco.pushEvents({
        E: step,
        ERRCODE: null,
        ERRMSG: null,
        ETIME: OrchCustomData.apiTimeStamp.unbindAppInstance[instanceName].endTime,
        LL: 'INFO',
        S: 200,
        STIME: OrchCustomData.apiTimeStamp.unbindAppInstance[instanceName].startTime,
        TY: 'RESPONSE',
        checkout_step: step,
        srcInitiatorId: OrchCustomData.srcInitiatorId[instanceName]
      });
      return Promise.resolve(obj);
    })
    .catch(err => {
      obj[instanceName] = err;
      return Promise.resolve(obj);
    });
};

/**
 * Vsb/Orch UnbindAppInstance
 * @param {object} data object with key idToken, value idToken string
 * @returns {promise} array of network responses
 */
const unbindAppInstance = data => {
  return new Promise(resolve => {
    const loadedSdk = OrchCustomData.srcSdks.loadedSdk;
    const { UNBIND_APP_INSTANCE } = apiMethodnames;
    const promiseArr = [];

    for (const key in loadedSdk) {
      OrchCustomData.apiTimeStamp.unbindAppInstance[key] = {};
      OrchCustomData.apiTimeStamp.unbindAppInstance[key].startTime = Date.now();
      const sdkInstance = loadedSdk[key];
      const unbindData = { ...data };
      if (key === DISCOVER) {
        delete unbindData.idToken;
      }
      const sdkPromise = promiseTimeout(
        promiseWrapper(sdkInstance, key, unbindData, UNBIND_APP_INSTANCE),
        timeOutError(key),
        promiseRejectError(key)
      );
      promiseArr.push(sdkPromise);
    }
    Promise.all(promiseArr).then(values => {
      for (const value of values) {
        OrchCustomData.setUnbind(value);
      }
      resolve(values);
    });
  });
};

export default unbindAppInstance;
